import BigNumber from "bignumber.js";

const computeUtil = {
  getPlus: function(...arr) {
    //加
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.plus(newNext).toNumber();
    });
    return newNumber;
  },
  getMinus: function(...arr) {
    //减
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.minus(newNext).toNumber();
    });
    return newNumber;
  },
  getMinusTwo: function(...arr) {
    //减
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.minus(newNext).toFormat(2);
    });
    return newNumber;
  },

  getMultiply: function(...arr) {
    //乘
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.times(newNext).toNumber();
    });
    return newNumber;
  },
  // 金额保存两位小数
  getMultiplyTwo: function(...arr) {
    //乘
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.times(newNext).toFormat(2);
    });
    return newNumber;
  },
  getDivided: function(...arr) {
    //除
    let newNumber = arr.reduce((pre, next) => {
      let newPre = new BigNumber(pre);
      let newNext = new BigNumber(next);
      return newPre.dividedBy(newNext).toNumber();
    });
    return newNumber;
  }
};

export default computeUtil;
